import * as endPoints from "../constants/v2/endPoints";
import * as apiService from "./apiService";

export const FEEDBACK_RATINGS = ["up", "down"];

export async function saveChatFeedback({
  conversationId,
  messageId,
  rating,
  reason,
}) {
  if (!conversationId || !messageId || !FEEDBACK_RATINGS.includes(rating)) {
    return null;
  }
  return apiService.apiCall(endPoints.HELP_CHAT_FEEDBACK, "POST", {
    conversationId,
    messageId,
    rating,
    reason: reason || null,
  });
}

export async function updateDraftField({ kind, id, key, value }) {
  if (!kind || !id || !key) return null;
  return apiService.apiCall(endPoints.HELP_CHAT_DRAFT_FIELD, "PATCH", {
    kind,
    id,
    key,
    value,
  });
}

export async function renameChatConversation(conversationId, title) {
  const trimmed = (title || "").trim();
  if (!conversationId || !trimmed) return null;
  return apiService.apiCall(
    endPoints.CHAT_CONVERSATION_RENAME(conversationId),
    "PATCH",
    { title: trimmed },
  );
}
